import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dashboard_inapp_ios",
  "use": "dashboard_inapp_ios-usage",
  "viewBox": "0 0 22 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 25\" id=\"dashboard_inapp_ios\"><path d=\"M13.25 12.95v7.768a2.732 2.732 0 01-2.733 2.732H3.983a2.732 2.732 0 01-2.733-2.732V5.183A2.733 2.733 0 013.983 2.45H5.75M1.25 18.95h12\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path clip-rule=\"evenodd\" d=\"M8.75 2.45a1.5 1.5 0 011.5-1.5h9a1.5 1.5 0 011.5 1.5v6a1.5 1.5 0 01-1.5 1.5h-9a1.5 1.5 0 01-1.5-1.5v-6z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M8.75 3.95h12M14.75 6.95h3\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/dashboard_inapp_ios.svg
// module id = Z/3y
// module chunks = 38 43